import React from "react";
import ProfilePageTemplate from "../shared/ProfilePageTemplate";

const IPOContent = () => {
  const OverviewContent = () => (
    <div className="p-8">
      <div className="space-y-8">
        {/* Definition Section */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Apa itu IPO?</h2>
          <p className="leading-relaxed text-base-content/70">
            Individual Police Officer (IPO) adalah personel kepolisian yang
            dikirim oleh negara kontributor (Police Contributing Country/PCC)
            secara individu untuk bertugas dalam misi pemeliharaan perdamaian
            Perserikatan Bangsa-Bangsa (PBB), di bawah struktur United Nations
            Police (UNPOL). Berbeda dengan Formed Police Unit (FPU) yang
            merupakan satuan berbentuk pasukan, IPO bertugas sebagai penasihat,
            pelatih, mentor, atau pengamat di lingkungan kepolisian negara tuan
            rumah (host state police) dalam misi perdamaian.
          </p>
        </div>

        {/* Functions Section */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Fungsi Utama IPO</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-base-100 rounded-lg p-6">
              <div className="flex items-start gap-4">
                <div className="text-3xl">💼</div>
                <div>
                  <h3 className="font-semibold text-lg mb-3">Advisory</h3>
                  <p className="text-base-content/70 leading-relaxed">
                    Memberikan saran kepada kepolisian lokal terkait reformasi
                    sektor keamanan, hukum, dan tata kelola kepolisian.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-base-100 rounded-lg p-6">
              <div className="flex items-start gap-4">
                <div className="text-3xl">🎓</div>
                <div>
                  <h3 className="font-semibold text-lg mb-3">
                    Mentoring dan Training
                  </h3>
                  <p className="text-base-content/70 leading-relaxed">
                    Membina dan melatih polisi lokal dalam aspek kepolisian yang
                    sesuai standar internasional, termasuk hak asasi manusia.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-base-100 rounded-lg p-6">
              <div className="flex items-start gap-4">
                <div className="text-3xl">👁️</div>
                <div>
                  <h3 className="font-semibold text-lg mb-3">
                    Monitoring dan Reporting
                  </h3>
                  <p className="text-base-content/70 leading-relaxed">
                    Melakukan pengawasan terhadap perilaku dan kinerja polisi
                    lokal serta melaporkan pelanggaran atau penyimpangan.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-base-100 rounded-lg p-6">
              <div className="flex items-start gap-4">
                <div className="text-3xl">🤝</div>
                <div>
                  <h3 className="font-semibold text-lg mb-3">
                    Community Policing
                  </h3>
                  <p className="text-base-content/70 leading-relaxed">
                    Membantu implementasi polisi masyarakat (community policing)
                    di wilayah misi.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* IPO vs FPU Comparison */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">IPO vs FPU</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-primary/10 rounded-lg p-6 border-2 border-primary/20">
              <h3 className="font-semibold text-lg mb-4 flex items-center gap-2">
                <span className="text-2xl">👤</span>
                Individual Police Officer (IPO)
              </h3>
              <ul className="space-y-2 text-base-content/70">
                <li className="flex items-start gap-2">
                  <span className="text-primary">•</span>
                  <span>Penugasan individual</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary">•</span>
                  <span>Peran sebagai penasihat dan mentor</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary">•</span>
                  <span>Fokus pada capacity building</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary">•</span>
                  <span>Berinteraksi langsung dengan polisi lokal</span>
                </li>
              </ul>
            </div>

            <div className="bg-secondary/10 rounded-lg p-6 border-2 border-secondary/20">
              <h3 className="font-semibold text-lg mb-4 flex items-center gap-2">
                <span className="text-2xl">👥</span>
                Formed Police Unit (FPU)
              </h3>
              <ul className="space-y-2 text-base-content/70">
                <li className="flex items-start gap-2">
                  <span className="text-secondary">•</span>
                  <span>Unit terorganisir (140 personel)</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-secondary">•</span>
                  <span>Operasi keamanan dan patroli</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-secondary">•</span>
                  <span>Perlindungan masyarakat sipil</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-secondary">•</span>
                  <span>Operasi dalam formasi unit</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const QualificationsContent = () => (
    <div className="p-8">
      <div className="space-y-8">
        {/* General Requirements */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Persyaratan Umum</h2>
          <p className="leading-relaxed text-base-content/70 mb-6">
            IPO harus memenuhi persyaratan umum dari United Nations Department
            of Peace Operations (UNDPO):
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div className="bg-base-100 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <div className="text-2xl">⏰</div>
                  <div>
                    <h3 className="font-semibold mb-2">
                      Pengalaman Kepolisian
                    </h3>
                    <p className="text-base-content/70 text-sm">
                      Memiliki pengalaman kepolisian aktif minimal 5 tahun
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-base-100 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <div className="text-2xl">🗣️</div>
                  <div>
                    <h3 className="font-semibold mb-2">Kemampuan Bahasa</h3>
                    <p className="text-base-content/70 text-sm">
                      Bahasa Inggris atau Prancis (minimal level intermediate)
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-base-100 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <div className="text-2xl">✅</div>
                  <div>
                    <h3 className="font-semibold mb-2">Rekam Jejak Bersih</h3>
                    <p className="text-base-content/70 text-sm">
                      Tidak memiliki catatan pelanggaran disiplin atau pidana
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <div className="bg-base-100 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <div className="text-2xl">💪</div>
                  <div>
                    <h3 className="font-semibold mb-2">Kesehatan</h3>
                    <p className="text-base-content/70 text-sm">
                      Kesehatan fisik dan mental yang baik
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-base-100 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <div className="text-2xl">🎯</div>
                  <div>
                    <h3 className="font-semibold mb-2">Uji Kompetensi</h3>
                    <p className="text-base-content/70 text-sm">
                      Lulus Assessment for Mission Service (AMS)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Assessment Details */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            Assessment for Mission Service (AMS)
          </h2>
          <p className="leading-relaxed text-base-content/70 mb-6">
            Tes kompetensi yang mencakup berbagai keterampilan yang diperlukan
            dalam misi internasional:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-base-100 rounded-lg p-6 text-center">
              <div className="text-3xl mb-3">🚗</div>
              <h3 className="font-semibold text-lg mb-3">
                Keterampilan Mengemudi
              </h3>
              <p className="text-base-content/70 text-sm">
                Kemampuan mengemudi kendaraan dalam kondisi medan yang menantang
              </p>
            </div>

            <div className="bg-base-100 rounded-lg p-6 text-center">
              <div className="text-3xl mb-3">🎯</div>
              <h3 className="font-semibold text-lg mb-3">Menembak</h3>
              <p className="text-base-content/70 text-sm">
                Keterampilan menembak dengan senjata api (jika diperlukan sesuai
                misi)
              </p>
            </div>

            <div className="bg-base-100 rounded-lg p-6 text-center">
              <div className="text-3xl mb-3">💻</div>
              <h3 className="font-semibold text-lg mb-3">Komputer</h3>
              <p className="text-base-content/70 text-sm">
                Penguasaan aplikasi komputer dan sistem informasi
              </p>
            </div>
          </div>
        </div>

        {/* Selection Process */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Proses Seleksi</h2>
          <div className="relative">
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-base-300"></div>
            <div className="space-y-6">
              <div className="flex items-start gap-6">
                <div className="bg-primary rounded-full w-16 h-16 flex items-center justify-center flex-shrink-0 relative z-10">
                  <span className="text-white font-bold">1</span>
                </div>
                <div className="bg-base-100 rounded-lg p-4 flex-1">
                  <h3 className="font-semibold text-lg mb-2">
                    Pendaftaran & Verifikasi
                  </h3>
                  <p className="text-base-content/70">
                    Pendaftaran kandidat dan verifikasi dokumen persyaratan
                    administratif
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-6">
                <div className="bg-secondary rounded-full w-16 h-16 flex items-center justify-center flex-shrink-0 relative z-10">
                  <span className="text-white font-bold">2</span>
                </div>
                <div className="bg-base-100 rounded-lg p-4 flex-1">
                  <h3 className="font-semibold text-lg mb-2">
                    Tes Psikologi & Kesehatan
                  </h3>
                  <p className="text-base-content/70">
                    Pemeriksaan psikologi dan kesehatan fisik untuk memastikan
                    kesiapan
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-6">
                <div className="bg-accent rounded-full w-16 h-16 flex items-center justify-center flex-shrink-0 relative z-10">
                  <span className="text-white font-bold">3</span>
                </div>
                <div className="bg-base-100 rounded-lg p-4 flex-1">
                  <h3 className="font-semibold text-lg mb-2">
                    Assessment for Mission Service
                  </h3>
                  <p className="text-base-content/70">
                    Tes kompetensi teknis dan keterampilan operasional
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-6">
                <div className="bg-success rounded-full w-16 h-16 flex items-center justify-center flex-shrink-0 relative z-10">
                  <span className="text-white font-bold">4</span>
                </div>
                <div className="bg-base-100 rounded-lg p-4 flex-1">
                  <h3 className="font-semibold text-lg mb-2">
                    Pre-Deployment Training
                  </h3>
                  <p className="text-base-content/70">
                    Pelatihan intensif sebelum penugasan ke wilayah misi
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Training Components */}
        <div className="bg-gradient-to-r from-primary/20 to-secondary/20 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            Komponen Pelatihan Pre-Deployment
          </h2>
          <div className="flex flex-col lg:flex-row gap-6">
            {/* Content Section */}
            <div className="lg:w-2/3">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-base-100 rounded-lg p-6">
                  <h3 className="font-semibold text-lg mb-4">
                    Pelatihan Teknis
                  </h3>
                  <ul className="space-y-2 text-base-content/70">
                    <li className="flex items-center gap-2">
                      <span className="text-primary">•</span>
                      <span>UN Peacekeeping Operations</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="text-primary">•</span>
                      <span>Human Rights & Gender Awareness</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="text-primary">•</span>
                      <span>Conflict Resolution</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="text-primary">•</span>
                      <span>Community Policing</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-base-100 rounded-lg p-6">
                  <h3 className="font-semibold text-lg mb-4">
                    Pelatihan Operasional
                  </h3>
                  <ul className="space-y-2 text-base-content/70">
                    <li className="flex items-center gap-2">
                      <span className="text-secondary">•</span>
                      <span>Cultural Awareness</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="text-secondary">•</span>
                      <span>Mission-Specific Briefing</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="text-secondary">•</span>
                      <span>Safety & Security Protocols</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="text-secondary">•</span>
                      <span>Communication Systems</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="bg-base-100 rounded-lg p-6 mt-6">
                <p className="text-base-content/70 leading-relaxed">
                  Pelatihan pre-deployment merupakan tahap krusial untuk
                  memastikan setiap IPO memiliki kompetensi dan kesiapan mental
                  yang diperlukan dalam menjalankan misi perdamaian
                  internasional dengan standar PBB yang tinggi.
                </p>
              </div>
            </div>

            {/* Images Section */}
            <div className="lg:w-1/3">
              <div className="bg-base-100 rounded-lg p-4">
                <h4 className="font-semibold mb-3 text-center">
                  Dokumentasi Pelatihan IPO
                </h4>
                <div className="grid gap-3">
                  {/* IPO images 0-3 */}
                  {[0, 1, 2, 3].map((imgNumber) => (
                    <div
                      key={imgNumber}
                      className="bg-base-200 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow"
                    >
                      <img
                        src={`/gallery/ipo/IPO_${imgNumber}.jpg`}
                        alt={`IPO pelatihan dokumentasi ${imgNumber + 1}`}
                        loading="lazy"
                        className="w-full h-32 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.src = "/placeholder-image.jpg";
                          target.alt = "Gambar tidak tersedia";
                        }}
                        onClick={() =>
                          window.open(
                            `/gallery/ipo/IPO_${imgNumber}.jpg`,
                            "_blank",
                          )
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const tabs = [
    {
      id: "overview",
      label: "Gambaran Umum",
      icon: "👤",
      component: <OverviewContent />,
    },
    {
      id: "qualifications",
      label: "Kualifikasi & Seleksi",
      icon: "📋",
      component: <QualificationsContent />,
    },
  ];

  return (
    <ProfilePageTemplate
      title="Individual Police Officer (IPO)"
      subtitle="Penasihat Kepolisian dalam Misi Perdamaian PBB"
      icon="👮‍♂️"
      breadcrumbBase="Misi Internasional"
      tabs={tabs}
      footerTitle="IPO Polri"
      footerDescription="Berkontribusi dalam membangun kapasitas kepolisian internasional melalui peran sebagai penasihat, mentor, dan pelatih dalam misi pemeliharaan perdamaian PBB."
      footerStats={[
        { label: "Pengalaman Minimal", value: "5 Tahun" },
        { label: "Total Kontribusi", value: "1022+" },
        { label: "Peran Utama", value: "4" },
      ]}
    />
  );
};

export default IPOContent;
